"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PointerStatus;
(function (PointerStatus) {
    PointerStatus["NEW"] = "NEW";
    PointerStatus["INVALID"] = "INVALID";
    PointerStatus["EXTENDING"] = "EXTENDING";
    PointerStatus["MOVING"] = "MOVING";
    PointerStatus["INSPECTING"] = "INSPECTING";
    PointerStatus["STOPPING"] = "STOPPING";
    PointerStatus["PINCHING"] = "PINCHING";
})(PointerStatus || (PointerStatus = {}));
exports.default = PointerStatus;
//# sourceMappingURL=PointerStatus.js.map